var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9706 7.9999C25.9706 7.44761 25.5228 6.9999 24.9706 6.9999L15.9706 6.9999C15.4183 6.9999 14.9706 7.44761 14.9706 7.9999C14.9706 8.55218 15.4183 8.9999 15.9706 8.9999L23.9706 8.9999L23.9706 16.9999C23.9706 17.5522 24.4183 17.9999 24.9706 17.9999C25.5228 17.9999 25.9706 17.5522 25.9706 16.9999L25.9706 7.9999ZM8.70711 25.6776L25.6777 8.707L24.2635 7.29279L7.29289 24.2634L8.70711 25.6776Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/linkArrow.501edb40239da7aee15ba3084b405d17.svg";
export { ForwardRef as ReactComponent };